import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[roof-type-5]',
    templateUrl: './roof-type-5.component.html',
    styleUrl: './roof-type-5.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType5Component {
}
